import GenericForm from 'components/GenericForm';
import type { GenericFormFields, SitecoreBlockProps } from 'models/sitecore';

interface Props extends SitecoreBlockProps {
	fields?: GenericFormFields;
}

export default function UserFeedbackForm({ fields }: Props) {
	if (!fields) {
		return null;
	}

	return (
		<GenericForm
			formLocation="UserFeedbackForm"
			sections={fields.sections}
			errorView={fields.error}
			successView={fields.success}
			loadingView={fields.loading}
		/>
	);
}
UserFeedbackForm.displayName = 'UserFeedbackForm_Partial';
